import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { LoadingService } from '@portal/loading/data-access';
import { catchError, finalize, throwError } from 'rxjs';
import { SendOtpResponse } from '../type/send-otp.type';
import { ApplicationApiService } from '../api/application-api.service';
import { ROUTE } from '../constant/route.constant';
import { RouteErrorCode } from '../type/route.type';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class SendOtpResolver implements Resolve<SendOtpResponse> {
  private readonly applicationApi = inject(ApplicationApiService);
  private readonly loadingService = inject(LoadingService);
  private readonly router = inject(Router);

  resolve(route: ActivatedRouteSnapshot) {
    const { QUERY_PARAM } = ROUTE.VERIFICATION;

    const appId = route.queryParamMap.get(QUERY_PARAM.CODE);
    const last4NRIC = route.queryParamMap.get(QUERY_PARAM.NRIC);

    if (!appId || !last4NRIC) {
      this.navigateErrorPage('403');
      return throwError(() => new Error('Missing required query params'));
    }

    this.loadingService.show();

    return this.applicationApi.sendOtp({ appId, last4NRIC }).pipe(
      catchError((error: HttpErrorResponse) => {
        const code = error?.error?.errorCode;
        switch (code) {
          case 'BIZ011':
            this.navigateErrorPage(ROUTE.ERROR.OFFER_EXPIRED);
            break;
        }

        return throwError(() => error);
      }),
      finalize(() => this.loadingService.hide()),
    );
  }

  private navigateErrorPage(errorCode?: RouteErrorCode): void {
    this.router.navigate([ROUTE.ERROR.MAIN, errorCode].filter(Boolean));
  }
}
